import { useEffect } from "react";

const REVIVE_SCRIPT_URL = "https://www.botb.com/www/delivery/asyncjs.php";

const REVIVE_ID = "6ee315d200a003a5ac39b07d0dd34156";

function loadReviveScript() {
  const adContainer = document.getElementById("script_ad_server");
  if (!adContainer || adContainer.querySelector("script")) return;

  const reviveScript = document.createElement("script");
  reviveScript.src = REVIVE_SCRIPT_URL;
  reviveScript.async = true;
  // Slots may already be in the DOM (SPA / deferred load). Refresh once the
  // script is ready so late-mounted <ins> tags still get filled.
  reviveScript.onload = () => {
    (
      window as Window & {
        reviveAsync?: Record<string, { refresh?: () => void }>;
      }
    ).reviveAsync?.[REVIVE_ID]?.refresh?.();
  };
  adContainer.appendChild(reviveScript);
}

function deferReviveScriptLoad() {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadReviveScript, { timeout: 3000 });
  } else {
    window.setTimeout(loadReviveScript, 2000);
  }
}

/** Loads Revive ad script after page load so it does not compete with LCP images. */
export default function useDeferredReviveAds() {
  useEffect(() => {
    const scheduleLoad = () => deferReviveScriptLoad();

    if (document.readyState === "complete") {
      scheduleLoad();
    } else {
      window.addEventListener("load", scheduleLoad, { once: true });
    }

    return () => {
      window.removeEventListener("load", scheduleLoad);
      const adContainer = document.getElementById("script_ad_server");
      if (adContainer) {
        adContainer.innerHTML = "";
      }
    };
  }, []);
}
